<script setup lang="ts">

import { Card } from '@/components/ui/card'
</script>

<template>
  <Card class="md:max-w-[390px] w-full p-8">
    <slot />
  </Card>
</template>

<style scoped>

</style>
